import { Divider, StackProps, VStack } from '@chakra-ui/react';
import { memo } from 'react';

export default memo(function SectionStack(props: StackProps) {
  return (
    <VStack divider={<Divider />} gap={0} alignItems={'stretch'} {...props} />
  );
});
